/**
 * Read-only summary of saved "Incorrect Logic" feedback for a criterion.
 *
 * Renders the reviewer's corrected-logic text inside the shared feedback card,
 * with an "Edit" affordance that reopens the feedback form.
 * @module IncorrectLogicSummary
 */
import React from "react";
import { FeedbackSummaryCard } from "./FeedbackSummaryCard";

/** Props for {@link IncorrectLogicSummary}. */
interface IncorrectLogicSummaryProps {
  /** The reviewer's corrected-logic text. */
  correctLogic: string;
  /** Invoked when the reviewer clicks "Edit" to reopen the feedback form. */
  onEdit: () => void;
}

/**
 * Renders the saved incorrect-logic summary card.
 *
 * @param props - The corrected-logic text and the edit handler
 * @returns The rendered summary, or null when there is no correction text
 */
export const IncorrectLogicSummary: React.FC<IncorrectLogicSummaryProps> = ({
  correctLogic,
  onEdit,
}) => {
  if (!correctLogic.trim().length) return null;

  return (
    <FeedbackSummaryCard title="Incorrect Logic" onEdit={onEdit}>
      <span className="text-[0.6875rem] font-normal leading-[1.03125rem] text-[#0F0F0F]">
        {correctLogic}
      </span>
    </FeedbackSummaryCard>
  );
};
